import moment from 'moment-timezone';
import { FONT_FAMILY , TOOLTIP_LABEL_FORMAT } from '@utils/constants';
import { humanize } from '@utils';
import { getMetricUnitByKey, getMetricUnitText } from '@utils/metrics';
import { DEFAULT_FILTER_COLOR } from '@src/utils/colorPalette';

export const formatMetricDataForChart = ({
  chartData,
  metricKey,
  color = DEFAULT_FILTER_COLOR,
  dodData = undefined,
}: {
  chartData: any;
  metricKey: any;
  color?: string;
  dodData?: any;
}) => {
  const tooltipFormatter = (params) => {
    const unit = getMetricUnitByKey({ metricKey });

    let xVal = '';
    let currentContent = '';
    let dodContent = '';

    params.forEach((param) => {
      const value = param.data;
      const yVal = humanize(value[1], unit);
      const marker = `<span style="display:inline-block;background-color:${param.color};width:7px;height:14px;position:relative;top:2px;margin-right:4px;"></span>`;

      if (param.seriesId === 'dod-series') {
        const dodDate = value[2]
          ? moment(value[2]).format(TOOLTIP_LABEL_FORMAT)
          : moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
        dodContent = `${dodDate}<br/>${marker}<span style="margin-right:10px;">${yVal}${getMetricUnitText(unit)}</span><br/>`;
      } else {
        xVal = moment(value[0]).format(TOOLTIP_LABEL_FORMAT);
        currentContent = `${marker}<span style="margin-right:10px;">${yVal}${getMetricUnitText(unit)}</span><br/>`;
      }
    });

    return `${xVal}<br/>${currentContent}${dodContent}`;
  };

  const option: any = {
    _viewType: 'timeseries',
    color: [color],
    grid: {
      left: 0,
      bottom: 0,
      right: 0,
      top: 5,
    },
    tooltip: {
      trigger: 'axis',
      formatter: tooltipFormatter,
      font: FONT_FAMILY,
      appendToBody: true,
      className: 'echarts-tooltip',
    },
    xAxis: {
      type: 'time',
      show: false,
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: [
      {
        id: 'primary-series',
        name: 'Current',
        data: chartData,
        type: 'line',
        showSymbol: false,
        areaStyle: {
          opacity: 0.1,
          color,
        },
        lineStyle: {
          width: 2,
        },
        z: 2,
      },
    ],
  };

  if (dodData && dodData.length > 0) {
    const dodColor = '#999999';
    const alignedDod = alignDodData(chartData, dodData);
    if (alignedDod.length > 0) {
      option.series = [
        {
          id: 'dod-series',
          name: 'Previous',
          data: alignedDod,
          type: 'line',
          showSymbol: false,
          areaStyle: { opacity: 0.1, color: dodColor },
          lineStyle: { width: 1.5, type: 'dashed', color: dodColor },
          z: 1,
        },
        ...option.series,
      ];
      option.color = ['#d9d9d9', color];
    }
  }

  return option;
};

const alignDodData = (currentData: any[] = [], dodData: any[] = []) => {
  if (!dodData.length || !currentData.length) return [];
  return currentData
    .map((currentPoint, index) => {
      if (index < dodData.length && dodData[index]) {
        return [currentPoint[0], dodData[index][1], dodData[index][0]]; // [2] = original DoD timestamp
      }
      return null;
    })
    .filter(Boolean);
};

// TODO: refactor as part of humanize cleanup
export const getHumanizedValueString = (data, metricKey) => {
  const value = humanize(data[metricKey] || 0, '');
  const unit = getMetricUnitByKey({ metricKey });
  if (unit) {
    const units = getMetricUnitText(unit);
    return `${value}${units}`;
  } else {
    return value;
  }
};
